/**
 * Application-wide configuration constants
 */

/**
 * Home/business location coordinates
 * Used for calculating delivery distances
 * Location: 42 Centre Ave East, Landmark, Manitoba
 */
export const HOME_COORDINATES = {
  lat: 49.66842907252495,
  lng: -96.81454311646675,
  address: '42 Centre Ave East, Landmark, Manitoba'
} as const;

/**
 * Distance calculation settings
 */
export const DISTANCE_CONFIG = {
  // Units for distance calculation
  unit: 'kilometers' as const,
  // Decimal places for distance display
  precision: 2
} as const;
